module.exports = __webpack_public_path__ + "img/圆柱形读卡器 (2).32f219ca.jpg";